export const AUTOMATION_TITLE_MAX_LENGTH = 80;

export const AUTOMATION_ACTION_TITLE_MAX_LENGTH = 80;
